import { useQuery, useMutation } from 'react-query'
import API from '.'

const ENDPOINT = '/api/maps'
const QUERY_KEY = 'maps'

export const useGetMap = (id, config = {}) =>
  useQuery([QUERY_KEY, id], async () => (await API.get(`${ENDPOINT}/${id}`)).data, config)

export const useGetMaps = (params) =>
  useQuery([QUERY_KEY, 'list', params], async () => (await API.get(`${ENDPOINT}`, { params })).data)

export const useGetMapsDashboard = (config = {}) =>
  useQuery(
    [QUERY_KEY, 'dashboard'],
    async () => (await API.get(`${ENDPOINT}/dashboard`)).data,
    config,
  )

export const useCreateMap = (config = {}) => useMutation((data) => API.post(ENDPOINT, data), config)

export const useUpdateMap = (config = {}) =>
  useMutation((data) => API.patch(`${ENDPOINT}/${data.id}`, data), config)

export const useDeleteMap = (config = {}) =>
  useMutation(({ id }) => API.delete(`${ENDPOINT}/${id}`), config)
